import React, { useEffect, useState } from 'react';
import TimePeriod from '../widget/TimePeriod';

const Cost: React.FC<{
  expirationDate: string;
  token: Token;
  onValueChange: (cost: number, years: number) => void;
}> = ({ onValueChange, expirationDate, token }) => {
  const [years, setYears] = useState(1);

  const handleSetYears = (years: number) => {
    setYears(years);
    onValueChange(token.basePrice * years, years);
  };

  useEffect(() => {
    onValueChange(token.basePrice * years, years);
  }, [token]);

  return (
    <TimePeriod
      years={years}
      date={expirationDate}
      handleSetYears={handleSetYears}
    />
  );
};

export default React.memo(Cost);
